import React from 'react';
import { FilterBadgeHookParams, AdCampaignBadgeHookResult } from '../types';

interface AdCampaign {
  id: string;
  name: string;
  adSets?: AdSet[];
}

interface AdSet {
  id: string;
  name: string;
}

interface UseAdCampaignBadges extends FilterBadgeHookParams {
  adCampaigns: AdCampaign[];
  adCampaignIds?: string[];
  adSetIds?: string[];
}

export const useAdCampaignBadges = ({
  adCampaigns,
  adCampaignIds = [],
  adSetIds = [],
}: UseAdCampaignBadges): AdCampaignBadgeHookResult => {
  const adCampaignBadges = React.useMemo(() => {
    const selectedCampaigns: AdCampaign[] = [];
    const selectedAdSets: AdSet[] = [];

    adCampaigns.forEach((campaign) => {
      // Check if campaign is selected
      if (adCampaignIds.includes(campaign.id)) {
        selectedCampaigns.push(campaign);
      }

      // Check if any ad sets from this campaign are selected
      campaign.adSets?.forEach((adSet) => {
        if (adSetIds.includes(adSet.id)) {
          selectedAdSets.push(adSet);
        }
      });
    });

    return {
      campaigns: selectedCampaigns,
      adSets: selectedAdSets,
    };
  }, [adCampaigns, adCampaignIds, adSetIds]);

  return {
    adCampaignBadgesProps: {
      data: adCampaignBadges,
    },
  };
};
